<template>
  <component
    :is="tag"
    :to="to"
    :href="href"
    class="slo-link"
    v-stack-x:2xs
    v-bind="$attrs"
    v-on="$listeners"
  >
    <slot />
  </component>
</template>

<script>
export default {
  name: 'SloLink',
  props: {
    to: {type: [String, Object]},
    href: {type: String}
  },
  computed: {
    tag() {
      if (typeof this.to !== 'undefined') return 'router-link';
      return 'a';
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../scss/system';

.slo-link {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  flex: 0 0 auto;
  width: auto;

  color: $color-blue-400;
  transition: color 300ms cubic-bezier(0.23, 1, 0.32, 1);
  cursor: pointer;

  &::before {
    content: '';
    position: absolute;
    top: -5px;
    right: -5px;
    bottom: -5px;
    left: -5px;
  }

  &::after {
    content: '';
    position: absolute;
    height: 1px;
    bottom: -4px;
    right: -1px;
    left: -1px;
    background: $color-blue-700;

    opacity: 0;
    transform: translateY(3px) scaleX(1.05);
    transition: 150ms cubic-bezier(0.23, 1, 0.32, 1);
    transition-property: opacity, transform;
  }

  &:focus,
  &:hover {
    color: $color-blue-700;

    &::after {
      opacity: 1;
      transform: translateY(0) scaleX(1);

      transition: 100ms cubic-bezier(0.23, 1, 0.32, 1);
      transition-property: opacity, transform;
    }
  }

  &:active {
    color: $color-blue-900;

    &::after {
      opacity: 1;
      transform: translateY(0) scaleX(1);

      transition: 100ms cubic-bezier(0.23, 1, 0.32, 1);
      transition-property: opacity, transform;
    }
  }

  &:disabled,
  &.disabled {
    color: #80b5da;
  }
}
</style>
